import { Music, Zap, Sparkles } from 'lucide-react';

// Piano keyboard mapping (legacy single-octave, used by VirtualKeyboard)
export const pianoKeyMap = [
    { note: 'C', type: 'white', keyboardKey: 'A' },
    { note: 'C#', type: 'black', keyboardKey: 'W' },
    { note: 'D', type: 'white', keyboardKey: 'S' },
    { note: 'D#', type: 'black', keyboardKey: 'E' },
    { note: 'E', type: 'white', keyboardKey: 'D' },
    { note: 'F', type: 'white', keyboardKey: 'F' },
    { note: 'F#', type: 'black', keyboardKey: 'T' },
    { note: 'G', type: 'white', keyboardKey: 'G' },
    { note: 'G#', type: 'black', keyboardKey: 'Y' },
    { note: 'A', type: 'white', keyboardKey: 'H' },
    { note: 'A#', type: 'black', keyboardKey: 'U' },
    { note: 'B', type: 'white', keyboardKey: 'J' },
];

// Musical Typing default map (Apple Logic style)
// Maps keyboard keys to semitone offsets from the base octave.
// The base octave is stored separately and can be shifted with Z/X.
// Velocity can be adjusted with C/V.
// Key -> { semitone offset from C of the base octave }
export const DEFAULT_MUSICAL_TYPING_MAP = {
    'A': 0,   // C
    'W': 1,   // C#
    'S': 2,   // D
    'E': 3,   // D#
    'D': 4,   // E
    'F': 5,   // F
    'T': 6,   // F#
    'G': 7,   // G
    'Y': 8,   // G#
    'H': 9,   // A
    'U': 10,  // A#
    'J': 11,  // B
    'K': 12,  // C (next octave)
    'O': 13,  // C# (next octave)
    'L': 14,  // D (next octave)
    'P': 15,  // D# (next octave)
    ';': 16,  // E (next octave)
    "'": 17,  // F (next octave)
};

export const NOTE_NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

export function semitoneToNoteName(semitone) {
    return NOTE_NAMES[((semitone % 12) + 12) % 12];
}

export function midiToNoteName(midi) {
    const octave = Math.floor(midi / 12) - 1;
    const noteIndex = midi % 12;
    return `${NOTE_NAMES[noteIndex]}${octave}`;
}

// Instrument configuration
export const instrumentConfigs = {
    piano: {
        color: '#3B82F6',
        bgGradient: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 50%, #60a5fa 100%)',
        icon: Music,
        keyStyle: 'piano',
        noteRange: { min: 36, max: 84 }
    },
    drums: {
        color: '#EF4444',
        bgGradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 50%, #f87171 100%)',
        icon: Zap,
        keyStyle: 'drums',
        noteRange: { min: 36, max: 51 },
        drumMap: {
            36: { name: 'kick', label: 'Kick', position: { x: 50, y: 70 }, size: 'large' },
            38: { name: 'snare', label: 'Snare', position: { x: 30, y: 40 }, size: 'medium' },
            42: { name: 'hihat', label: 'Hi-Hat', position: { x: 15, y: 20 }, size: 'small' },
            46: { name: 'openhat', label: 'Open Hat', position: { x: 25, y: 15 }, size: 'small' },
            49: { name: 'crash', label: 'Crash', position: { x: 10, y: 10 }, size: 'medium' },
            51: { name: 'ride', label: 'Ride', position: { x: 80, y: 15 }, size: 'medium' },
            45: { name: 'tom1', label: 'High Tom', position: { x: 45, y: 25 }, size: 'small' },
            47: { name: 'tom2', label: 'Mid Tom', position: { x: 60, y: 30 }, size: 'medium' },
            43: { name: 'tom3', label: 'Floor Tom', position: { x: 75, y: 50 }, size: 'large' },
            57: { name: 'splash', label: 'Splash', position: { x: 70, y: 10 }, size: 'small' }
        }
    },
    bass: {
        color: '#10B981',
        bgGradient: 'linear-gradient(135deg, #047857 0%, #10b981 50%, #34d399 100%)',
        icon: Music,
        keyStyle: 'bass',
        noteRange: { min: 28, max: 52 }
    },
    synth: {
        color: '#8B5CF6',
        bgGradient: 'linear-gradient(135deg, #7c3aed 0%, #8b5cf6 50%, #a78bfa 100%)',
        icon: Sparkles,
        keyStyle: 'synth',
        noteRange: { min: 36, max: 84 }
    }
}; 